/** Mismos códigos que consume GET /api/InventarioInformes/movimientos-stock (tipoMovimiento). */
export const TIPOS_MOVIMIENTO_STOCK = {
  '11-POS': 'AJUSTE STOCK POSITIVO',
  '11-NEG': 'AJUSTE STOCK NEGATIVO',
  '8-POS': 'TRANSFERENCIA POSITIVO',
  '8-NEG': 'TRANSFERENCIA NEGATIVO',
  '1-VEN': 'FACTURA VENTAS',
  '1-COM': 'FACTURA COMPRAS',
  '3-VEN': 'NOTA CREDITO VENTAS',
  '3-COM': 'NOTA CREDITO COMPRAS',
  '45': 'DEVOLUCION',
  '9': 'REMITO VENTAS',
  '16': 'REMITO COMPRAS',
} as const;

export type TipoMovimientoStockCodigo = keyof typeof TIPOS_MOVIMIENTO_STOCK;
